<template>
  <v-list three-line>
    <v-list-item-group>
      <v-subheader>最近の提出</v-subheader>
      <template v-for="item in currentItems">
        <RecentResultListItem :key="item.id" :code="item" />
      </template>
    </v-list-item-group>
  </v-list>
<!--
  <div>
    最近の提出
    <RecentResultListItem v-for="item in currentItems" :key="item.id" :code="item" />
  </div>
-->
</template>

<script>
import RecentResultListItem from '@/components/RecentResultListItem.vue'

export default {
  components: {
    RecentResultListItem,
  },
  props: [
    'query',
  ],
  data: () => ({
    results: [],
    itemsPerPage: 6,
  }),
  computed: {
    currentItems: function() {
      return this.results.slice(0, this.itemsPerPage)
    },
  },
  methods: {
    bind: function () {
      if (this.query)
      {
        let query = this.query
        query = query.orderBy("submittedAt", "desc")
        this.$bind("results", query.limit(this.itemsPerPage))
      }
    },
  },
  watch: {
    maxPage: function () { this.bind() },
    query:   function () { this.page = 0; this.bind() },
  },
  created() {
    this.bind()
  },
};
</script>


